<template>
  <div class="filter-visa-type">
    <div
      class="visa-type-item"
      v-for="item in countryInfo.visa_type_list"
      :key="item"
      :class="{ active: item === inner_visa_type }"
      @click="changeVisaType(item)"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    visa_type: String,
    countryInfo: Object,
  },
  data() {
    return {};
  },
  computed: {
    inner_visa_type: {
      get() {
        return this.visa_type;
      },
      set(value) {
        this.$emit('update:visa_type', value);
      },
    },
  },
  created() {},
  methods: {
    changeVisaType(value) {
      this.inner_visa_type = value;
    },
  },
};
</script>

<style lang="less" scoped>
.filter-visa-type {
  flex-grow: 1;
  align-self: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: flex-start;
  height: 62px;
  .visa-type-item {
    display: flex;
    align-items: center;
    color: #222222;
    font-size: 14px;
    height: 43px;
    position: relative;
    white-space: nowrap;
    margin-right: 24px;
    cursor: pointer;
    &:first-child {
      margin-left: 24px;
    }
    &:hover {
      color: #337eff;
    }
    &.active {
      color: #337eff;
      font-weight: 600;
      &::after {
        content: '';
        width: 42px;
        height: 2px;
        background: #337eff;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
